import React, { Component } from "react";
import { Table, Button, Input } from "antd";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import { reactLocalStorage } from "reactjs-localstorage";
import SelectBox from "../../components/common/SelectBox";
import {ethFeeString, requestString, toggleCode } from "../../lib/util/codeUtil";
import {
  formatDate,
  amountFormat,
  coinMultiFormat,
  coinDivideFormat
} from "../../lib/util/numberUtil";

export default class MergeList extends Component {
  state = {
    pagination: {
      total: 0,
      current: 1,
      pageSize: 50
    },
    coinType: 2,
    coinList: [],
    mergeList: [],

    selectedRowKeys: [],
    selectedRows: [],
    isFee: 0,
    mergeType: "MERGE",
    loading: false
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
      selectedRowKeys: [],
      selectedRows: []
    });
    this.getMergeList({
      pageNum: pager.current
    });
  };

  handleChangeCoinType = (value) => {
    const coinCategory = this.state.coinList.find(
      (list) => list.coinType === value
    ).category;
    this.setState(
      {
        coinType: value,
        isFee: 0,
        selectedRowKeys: [],
        selectedRows: [],
        mergeType: coinCategory === "ERC20" || coinCategory === "BEP20" || coinCategory === "METIC20" ? "FEE" : "MERGE"
      },
      () => {
        this.getMergeList({});
      }
    );
  };

  handleChangeIsFee = (value) => {
    let isFee = parseInt(value);
    // console.log(`isFee value: ${isFee} ${typeof isFee}`);
    console.log(this.state.coinList)
    console.log(value)
    const coinCategory = this.state.coinList.find((list) => list.coinType === this.state.coinType).category;
    this.setState(
      {
        isFee: isFee,
        selectedRowKeys: [],
        selectedRows: [],
        mergeType:
          this.state.coinType &&
          (coinCategory === "ERC20" || coinCategory === "BEP20" || coinCategory === "METIC20") &&
          isFee === 0
            ? "FEE"
            : "MERGE"
      },
      () => {
        this.getMergeList();
      }
    );
  };

  onRowSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
      selectedRows: selectedRows.map((row) => {
        return {
          ...row,
          balance: coinDivideFormat(row.balance, row.coinType)
        };
      })
    });
  };

  handleBalanceChange = (value, address) => {
    this.setState({
      selectedRows: this.state.selectedRows.map((row) => {
        if (row.address === address) {
          return {
            ...row,
            balance: value
          };
        } else {
          return row;
        }
      })
    });
  };

  onMerge = () => {
    if (this.state.selectedRows.length === 0) {
      alert("선택된 행이 없습니다.");
    } else {
      let updateData = {
        walletMergeList: this.state.selectedRows.map((row) => {
          if (this.state.mergeType === "MERGE") {
            return {
              address: row.address,
              amount: coinMultiFormat(row.balance, row.coinType),
              coinType: row.coinType,
              type: "MERGE"
            };
          } else {
            return {
              address: row.address,
              coinType: row.coinType,
              type: "FEE"
            };
          }
        })
      };
      if (
        global.confirm(
          `${
            this.state.mergeType === "MERGE" ? "지갑모으기를" : "수수료지급을"
          } 실행하시겠습니까 ?`
        )
      ) {
        this.setState({ loading: true });
        // console.log(JSON.stringify(updateData, null, 4));
        httpPost(httpUrl.walletMerge, [], updateData).then((res) => {
          alert("완료되었습니다.");
          this.setState({
            selectedRowKeys: [],
            selectedRows: [],
            mergeType: "MERGE",
            loading: false
          });
          this.getMergeList();
        }).catch((error) => {
          this.setState({ loading: false });
          console.error("Error:", error);
        });
      }
    }
  };

  getMergeList = (params = {}) => {
    const { coinType, isFee } = this.state;
    let pageNum = params.pageNum || 1;
    let fee = isFee || 0;
    httpGet(httpUrl.getMergeList, [50, pageNum, coinType, fee], {}).then(
      (res) => {
        const pagination = { ...this.state.pagination };
        pagination.total = res.data.totalCount;
        this.setState({
          mergeList: res.data.blockchainBalanceList,
          pagination
        });
      }
    );
  };

  onRefresh = () => {
    this.getMergeList();
  };

  componentDidMount() {
    this.setState({ coinList: reactLocalStorage.getObject("coinList") }, ()=>{
      this.handleChangeCoinType(401)
    });
    // httpGet(httpUrl.getBlockchainList, [], {}).then(res => {
    //   this.setState({ coinList: res.data }, ()=>{
    //       this.handleChangeCoinType(2)
    //     });
    // })
  }

  render() {
    const {
      coinType,
      isFee,
      mergeList,
      selectedRowKeys,
      selectedRows,
      loading
    } = this.state;

    let coinCategory = "";
    try {
      coinCategory = this.state.coinList.find((list) => list.coinType === coinType).category;
    }
    catch{

    }

    let mergeType =
      coinType &&
      (coinCategory === "ERC20" || coinCategory === "BEP20" || coinCategory === "METIC20") &&
      isFee === 0
        ? "FEE"
        : "MERGE";

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onRowSelectChange,
      getCheckboxProps: (record) => ({
        disabled: record.requestFlag === 1
      })
      //record.ethFee === 1 : record.ethFee === 0
      //this.state.coinList.find(coin => coin.coinType === record.coinType).category === 'MAINNET'
    };
    const mergeListColumn = [
      {
        title: "코인종류",
        dataIndex: "coinType",
        key: "coinType",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => (
          <div>
            {this.state.coinList.find((list) => list.coinType === data).name}
          </div>
        )
      },
      {
        title: "일자",
        dataIndex: "updateDate",
        key: "updateDate",
        className: "support-column-number fs-15 lh-21",
        render: (data) => <span>{formatDate(data)}</span>
      },
      {
        title: "주소",
        dataIndex: "address",
        key: "address",
        className: "support-column-number fs-15 lh-21"
      },
      {
        title: "잔액",
        dataIndex: "balance",
        key: "balance",
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
          <div>
            {mergeType === "MERGE" &&
            selectedRows.find((sr) => sr.address === row.address) ? (
              <Input
                style={{ width: "180px" }}
                value={
                  selectedRows.find((sr) => sr.address === row.address).balance
                }
                onChange={(e) => {
                  this.handleBalanceChange(e.target.value, row.address);
                }}
              />
            ) : (
              <span>{amountFormat(data, row.coinType)}</span>
            )}
            {/* {data} */}
          </div>
        )
      },

      coinType !== 1 && coinType !== 2 && coinType !== 4 && coinType !== 5
        ? {
            title: "수수료보유 여부",
            dataIndex: "ethFee",
            key: "ethFee",
            className: "support-column-number fs-15 lh-21",
            render: (data) => <span>{ethFeeString[data]}</span>
          }
        : {
            colSpan: 0,
            width: 0,
            render: () => {
              return {
                props: {
                  colSpan: 0
                }
              };
            }
          },
      {
        title: "요청 상태",
        dataIndex: "requestFlag",
        key: "requestFlag",
        className: "support-column-number fs-15 lh-21",
        render: (data) => <span>{requestString[data]}</span>
      }
    ];

    return (
      <div className="main">
        <div className="main-title">
          지갑 모으기
        </div>
        <div className="top-bar">
          <div id="selectBox">
            <div className="text-box">
              코인선택
            </div>
            <CoinSelectBox
              name="searchType"
              className="memo-select2" 
              style={{width:100, marginRight:10, marginLeft:10}}
              placeholder="코인 종류를 선택해주세요."
              value={coinType}
              onChange={this.handleChangeCoinType}
              exceptCoinType={[1, 3]}
            />
            {coinType &&
              (coinCategory === "ERC20" || coinCategory === "BEP20" || coinCategory === "METIC20") && (
                <>
                  <SelectBox
                    placeholder="수수료 보유여부를 선택해주세요."
                    value={ethFeeString[isFee]}
                    code={toggleCode}
                    codeString={ethFeeString}
                    onChange={this.handleChangeIsFee}
                    style={{ width: "280px" }}
                  />
                  <Button
                    onClick={this.onRefresh}
                    style={{ marginLeft: "10px" }}
                  >
                    새로고침
                  </Button>
                </>
              )}
            </div>
            <div style={{ float: "right" }}>
              <label className="text-box" htmlFor="mergeType">작업 내용</label>
              <label className="text-box" htmlFor="mergeType">:</label>
            <span className="text-box" style={{ color: "blue", fontSize: "bold" }}>
              {coinType &&
              (coinCategory === "ERC20" || coinCategory === "BEP20" || coinCategory === "METIC20") &&
              isFee === 0
                ? "수수료지급"
                : "지갑모으기"}
              &nbsp;&nbsp;
            </span>
            <Button
              onClick={() => {
                this.onMerge();
              }}
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginRight: "10px", color: "white" }}>
              실행
            </Button>
            <Button
              onClick={() => {
                this.setState({
                  selectedRowKeys: [],
                  selectedRows: [],
                  mergeType: "MERGE"
                });
              }}>
              취소
            </Button>
          </div>
        </div>  
        {/* {selectedRows.length !== 0 && (
        )} */}
        <div className="top-table">
          <Table
            rowKey={(record, index) => index}
            columns={mergeListColumn}
            dataSource={mergeList}
            pagination={this.state.pagination}
            onChange={this.handleTableChange}
            rowSelection={rowSelection}
          />
        </div>
      </div>
    );
  }
}
